<template>
  <div
    class="message__system animate__animated animate__fadeInUp animate__faster"
    :class="{'is-pending': isPendingMessage}"
  >
    {{ messageContent }}
    <div class="message__system-content" v-if="isPendingMessage">
      {{ messageContent }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messageContent: {
      type: String,
      default: '',
    },
    isPendingMessage: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.message__system {
  @apply bg-purple-10 rounded-xl w-max relative;
  @apply mb-3;
  padding-left: 17.5px;
  padding-right: 17.5px;
  padding-top: 13px;
  padding-bottom: 13px;
  max-width: 270px;
  &.is-pending {
    animation: rotating 3s linear infinite;
    background: conic-gradient(from var(--r), #F1F0F9 0%, #7F58F0 10%, #F1F0F9 20%);
  }
  .message__system-content {
    @apply bg-purple-10 rounded-xl py-3 px-4 w-max mb-3;
    @apply absolute inset-0.25 z-1 text-sm break-words;
    top: 1px;
    left: 1.5px;
    height: max-content;
    transition: opacity .3s ease;
  }
}

@property --r {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}

@keyframes rotating {
  0% {
    --r: 0deg;
  }
  100% {
    --r: 360deg;
  }
}

@property --x {
  syntax: '<length>';
  inherits: false;
  initial-value: 0px;
}

@keyframes x {
  /* w:h === 6:1 */
  /* with a 80px x-margin */
  0% {
    --x: 80px;
  }
  /* 6/(6+3.14) * 50% */
  32.82275711% {
    --x: 520px;
  }
  50% {
    --x: 520px;
  }
  /* 50% + 32.8% */
  82.82275711% {
    --x: 80px;
  }
  100% {
    --x: 80px;
  }
}

</style>
